var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsBoolean, IsInt, IsOptional, IsString, Matches, Min, ValidateNested, } from 'class-validator';
import { LOCAL_ISO_REGEX, RRULE_REGEX } from '../constants.js';
import { UpdateAppointmentSeriesDefaultsDto } from './update-appointment-series-defaults.dto.js';
/**
 * Edit-all: change the series's rrule (and optionally defaults).
 *
 * Soft-warn pre-flight: callers should first invoke `check-conflicts`. To
 * proceed despite conflicts, set `confirmConflicts: true`.
 *
 * For TP-linked series, the new `expectedOccurrenceCount` must match the new
 * rrule's COUNT and fit within the treatment plan's remaining quota.
 */
export class UpdateAppointmentSeriesRruleDto {
    rrule;
    dtstartLocal;
    expectedOccurrenceCount;
    newDefaults;
    confirmConflicts;
}
__decorate([
    IsString(),
    Matches(RRULE_REGEX, {
        message: 'rrule must be a valid RFC 5545 RRULE string',
    }),
    __metadata("design:type", String)
], UpdateAppointmentSeriesRruleDto.prototype, "rrule", void 0);
__decorate([
    Matches(LOCAL_ISO_REGEX, {
        message: 'dtstartLocal must be local-time ISO `YYYY-MM-DDTHH:mm:ss` (no offset)',
    }),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAppointmentSeriesRruleDto.prototype, "dtstartLocal", void 0);
__decorate([
    IsInt(),
    Min(1),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateAppointmentSeriesRruleDto.prototype, "expectedOccurrenceCount", void 0);
__decorate([
    ValidateNested(),
    Type(() => UpdateAppointmentSeriesDefaultsDto),
    IsOptional(),
    __metadata("design:type", UpdateAppointmentSeriesDefaultsDto)
], UpdateAppointmentSeriesRruleDto.prototype, "newDefaults", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateAppointmentSeriesRruleDto.prototype, "confirmConflicts", void 0);
//# sourceMappingURL=update-appointment-series-rrule.dto.js.map